import React, { useState, useEffect } from "react";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { useSelector } from "react-redux";

// Import existing React Icons used in the project
import { FaHome, FaClock, FaSpinner, FaUndo, FaKey } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import {
  MdWaterDrop,
  MdCreditScore,
  MdPayment,
  MdOutlineTipsAndUpdates,
  MdSecurity,
} from "react-icons/md";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { RxDashboard } from "react-icons/rx";
import { IoPersonOutline } from "react-icons/io5";

const TenantTourMobile = ({
  runTour,
  onTourEnd,
  sharedValue,
  setSharedValue,
  resumeAtStep,
}) => {
  const { user } = useSelector((state) => state.landlordslice);
  const [tourState, setTourState] = useState({
    run: false,
    stepIndex: 0,
    steps: [],
  });

  // Define tour steps for Mobile devices
  const tourSteps = [
    {
      target: "body",
      content: (
        <div>
          <h3
            style={{
              color: "#192A3A",
              marginBottom: "12px",
              fontFamily: "Karla, sans-serif",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              textAlign: "center",
              fontSize: "16px",
            }}
          >
            <MdSecurity style={{ fontSize: "18px", color: "#B39359" }} />
            Welcome! Let's Secure Your Account
          </h3>
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "13px",
              lineHeight: "1.4",
            }}
          >
            Welcome to Rently Buzz! For your security, we recommend changing
            your password to something more secure.
          </p>
          <div
            style={{
              marginTop: "12px",
              padding: "8px",
              backgroundColor: "#f8f6f3",
              borderRadius: "6px",
              border: "1px solid #B39359",
            }}
          >
            <strong
              style={{
                fontFamily: "Karla, sans-serif",
                color: "#192A3A",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginBottom: "6px",
                fontSize: "14px",
              }}
            >
              <FaKey style={{ fontSize: "14px", color: "#B39359" }} />
              Password Tips:
            </strong>
            <ul
              style={{
                marginTop: "6px",
                paddingLeft: "16px",
                fontFamily: "Poppins, sans-serif",
                fontSize: "12px",
              }}
            >
              <li>Use 8+ characters</li>
              <li>Mix letters & numbers</li>
              <li>Add special characters</li>
            </ul>
          </div>
          <p
            style={{
              marginTop: "8px",
              fontSize: "12px",
              color: "#6b7280",
              fontFamily: "Poppins, sans-serif",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            Tap "Next" to go to your profile page.
          </p>
        </div>
      ),
      placement: "center",
      disableBeacon: true,
      styles: {
        options: {
          primaryColor: "#192A3A",
        },
      },
    },
    {
      target: ".change-password-button",
      content: (
        <div>
          <h3
            style={{
              color: "#192A3A",
              marginBottom: "12px",
              fontFamily: "Karla, sans-serif",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              textAlign: "center",
              fontSize: "16px",
            }}
          >
            <FaKey style={{ fontSize: "18px", color: "#B39359" }} />
            Change Your Password
          </h3>
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "13px",
              lineHeight: "1.4",
            }}
          >
            Tap this button to update your password for better security.
          </p>
          <div
            style={{
              marginTop: "10px",
              padding: "8px",
              backgroundColor: "#f8f6f3",
              borderRadius: "6px",
              border: "1px solid #B39359",
            }}
          >
            <strong
              style={{
                fontFamily: "Karla, sans-serif",
                color: "#192A3A",
                fontSize: "14px",
                display: "block",
                marginBottom: "6px",
              }}
            >
              <MdSecurity
                style={{
                  fontSize: "14px",
                  color: "#B39359",
                  marginRight: "4px",
                }}
              />
              Why change it?
            </strong>
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "12px",
                margin: "0",
              }}
            >
              Protects your account and rental information from unauthorized
              access.
            </p>
          </div>
          <p
            style={{
              marginTop: "8px",
              fontSize: "12px",
              color: "#6b7280",
              fontFamily: "Poppins, sans-serif",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            Change it now or continue the tour.
          </p>
        </div>
      ),
      placement: "top",
      styles: {
        options: {
          primaryColor: "#192A3A",
        },
      },
    },
    {
      target: ".cards-container",
      content: (
        <div>
          <h3
            style={{
              color: "#192A3A",
              marginBottom: "12px",
              fontFamily: "Karla, sans-serif",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              textAlign: "center",
              fontSize: "16px",
            }}
          >
            <RxDashboard style={{ fontSize: "18px", color: "#B39359" }} />
            Payment Progress Report
          </h3>
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "13px",
              lineHeight: "1.4",
            }}
          >
            Welcome! These cards show your payment progress and financial status
            at a glance.
          </p>
          <ul
            style={{
              marginTop: "8px",
              paddingLeft: "16px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "12px",
              lineHeight: "1.3",
            }}
          >
            <li>
              <strong>Pending Payments:</strong> Outstanding amounts
            </li>
            <li>
              <strong>Completed Payments:</strong> Payment history
            </li>
            <li>
              <strong>Progress Bars:</strong> Visual payment completion
            </li>
          </ul>
          <p
            style={{
              marginTop: "8px",
              fontSize: "11px",
              color: "#6b7280",
              fontFamily: "Poppins, sans-serif",
              fontStyle: "italic",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <MdOutlineTipsAndUpdates
              style={{ fontSize: "20px", color: "#B39359" }}
            />
            Swipe or scroll to see all your payment cards!
          </p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
      styles: {
        options: {
          primaryColor: "#192A3A",
          width: 280,
        },
        tooltip: {
          fontSize: 13,
        },
        buttonNext: {
          fontSize: 12,
          padding: "8px 16px",
        },
        buttonBack: {
          fontSize: 12,
          padding: "8px 16px",
        },
      },
    },
    {
      target: ".quick-links-container",
      content: (
        <div>
          <h3
            style={{
              color: "#B39359",
              marginBottom: "12px",
              fontFamily: "Karla, sans-serif",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              textAlign: "center",
              fontSize: "16px",
            }}
          >
            <MdPayment style={{ fontSize: "18px", color: "#192A3A" }} />
            Quick Payment Links
          </h3>
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "13px",
              lineHeight: "1.4",
            }}
          >
            Make payments instantly! Tap any card to pay specific bills directly
            from this overview.
          </p>
          <div
            style={{
              marginTop: "10px",
              padding: "8px",
              backgroundColor: "#f8f6f3",
              borderRadius: "6px",
              border: "1px solid #B39359",
            }}
          >
            <strong
              style={{
                fontFamily: "Karla, sans-serif",
                color: "#192A3A",
                display: "block",
                textAlign: "center",
                marginBottom: "6px",
                fontSize: "12px",
              }}
            >
              Available payments:
            </strong>
            <ul
              style={{
                marginTop: "6px",
                paddingLeft: "16px",
                fontFamily: "Poppins, sans-serif",
                fontSize: "11px",
                lineHeight: "1.2",
              }}
            >
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "3px",
                }}
              >
                <FaHome style={{ color: "#B39359", fontSize: "12px" }} />
                <strong>Rent</strong> - Monthly payments
              </li>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "3px",
                }}
              >
                <MdWaterDrop style={{ color: "#B39359", fontSize: "12px" }} />
                <strong>Water</strong> - Utility bills
              </li>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "3px",
                }}
              >
                <FaClock style={{ color: "#B39359", fontSize: "12px" }} />
                <strong>Arrears</strong> - Outstanding amounts
              </li>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "3px",
                }}
              >
                <LiaFileInvoiceSolid
                  style={{ color: "#B39359", fontSize: "12px" }}
                />
                <strong>Service Charge</strong> - Property fees
              </li>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "3px",
                }}
              >
                <FaSpinner style={{ color: "#B39359", fontSize: "12px" }} />
                <strong>Unpaid Deposit</strong> - Security deposits
              </li>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <FaTrash style={{ color: "#B39359", fontSize: "12px" }} />
                <strong>Garbage</strong> - Waste management
              </li>
            </ul>
          </div>
          <p
            style={{
              marginTop: "8px",
              fontSize: "11px",
              color: "#6b7280",
              fontFamily: "Poppins, sans-serif",
              fontStyle: "italic",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <MdOutlineTipsAndUpdates
              style={{ fontSize: "20px", color: "#B39359" }}
            />
            Tap any card to open payment with pre-filled amounts!
          </p>
        </div>
      ),
      placement: "top",
      styles: {
        options: {
          primaryColor: "#B39359",
          width: 280,
        },
        tooltip: {
          fontSize: 13,
        },
        buttonNext: {
          fontSize: 12,
          padding: "8px 16px",
        },
        buttonBack: {
          fontSize: 12,
          padding: "8px 16px",
        },
      },
    },
    {
      target: ".transactions-container",
      content: (
        <div>
          <h3
            style={{
              color: "#192A3A",
              marginBottom: "12px",
              fontFamily: "Karla, sans-serif",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              textAlign: "center",
              fontSize: "16px",
            }}
          >
            <MdCreditScore style={{ fontSize: "18px", color: "#B39359" }} />
            Recent Transactions
          </h3>
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "13px",
              lineHeight: "1.4",
            }}
          >
            View your latest payment transactions here. This shows your most
            recent payment activity and history.
          </p>
          <div
            style={{
              marginTop: "10px",
              padding: "8px",
              backgroundColor: "#f4f2ef",
              borderRadius: "6px",
              border: "1px solid #192A3A",
            }}
          >
            <ul
              style={{
                paddingLeft: "16px",
                fontFamily: "Poppins, sans-serif",
                fontSize: "12px",
                lineHeight: "1.3",
              }}
            >
              <li>
                <strong>Payment Date:</strong> When the payment was made
              </li>
              <li>
                <strong>Amount:</strong> Total payment amount
              </li>
              <li>
                <strong>Payment Type:</strong> Category of payment
              </li>
              <li>
                <strong>Status:</strong> Confirmation of successful payment
              </li>
            </ul>
          </div>
          <p
            style={{
              marginTop: "8px",
              fontSize: "11px",
              color: "#6b7280",
              fontFamily: "Poppins, sans-serif",
              fontStyle: "italic",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <MdOutlineTipsAndUpdates
              style={{ fontSize: "20px", color: "#B39359" }}
            />
            Transactions update automatically after each payment!
          </p>
        </div>
      ),
      placement: "top",
      styles: {
        options: {
          primaryColor: "#192A3A",
          width: 280,
        },
        tooltip: {
          fontSize: 13,
        },
        buttonNext: {
          fontSize: 12,
          padding: "8px 16px",
        },
        buttonBack: {
          fontSize: 12,
          padding: "8px 16px",
        },
      },
    },
    {
      target: ".mobile-nav",
      content: (
        <div>
          <h3
            style={{
              color: "#B39359",
              marginBottom: "12px",
              fontFamily: "Karla, sans-serif",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              textAlign: "center",
              fontSize: "16px",
            }}
          >
            <IoPersonOutline style={{ fontSize: "18px", color: "#192A3A" }} />
            Mobile Navigation
          </h3>
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "13px",
              lineHeight: "1.4",
            }}
          >
            Navigate between different sections using this bottom navigation
            bar.
          </p>
          <div
            style={{
              marginTop: "10px",
              padding: "8px",
              backgroundColor: "#f8f6f3",
              borderRadius: "6px",
              border: "1px solid #B39359",
            }}
          >
            <ul
              style={{
                marginTop: "6px",
                paddingLeft: "16px",
                fontFamily: "Poppins, sans-serif",
                fontSize: "12px",
                lineHeight: "1.3",
              }}
            >
              <li>
                <strong>Overview:</strong> Payment dashboard & quick links
              </li>
              <li>
                <strong>Payments:</strong> Make new payments
              </li>
              <li>
                <strong>Invoices:</strong> View all invoices
              </li>
              <li>
                <strong>Messages:</strong> Chat with management
              </li>
              <li>
                <strong>Profile:</strong> Manage your account
              </li>
            </ul>
          </div>
          <p
            style={{
              marginTop: "8px",
              fontSize: "11px",
              color: "#6b7280",
              fontFamily: "Poppins, sans-serif",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            🎉 Tour complete! You're ready to manage your payments efficiently!
          </p>
        </div>
      ),
      placement: "top",
      styles: {
        options: {
          primaryColor: "#B39359",
          width: 280,
        },
        tooltip: {
          fontSize: 13,
        },
        buttonNext: {
          fontSize: 12,
          padding: "8px 16px",
        },
        buttonBack: {
          fontSize: 12,
          padding: "8px 16px",
        },
      },
    },
  ];

  useEffect(() => {
    if (runTour) {
      setTourState({
        run: true,
        stepIndex: resumeAtStep !== null ? resumeAtStep : 0,
        steps: tourSteps,
      });
    }
  }, [runTour, resumeAtStep]);

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if (
      [STATUS.FINISHED, STATUS.SKIPPED].includes(status) ||
      action === ACTIONS.CLOSE
    ) {
      setTourState({ ...tourState, run: false });

      // Mark tour as completed for this user
      localStorage.setItem(
        `tenant_tour_completed_mobile_${user?.data?.user?.user_id}`,
        "true"
      );

      if (onTourEnd) {
        onTourEnd();
      }
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

      // Special handling for switching between Profile and Dashboard views
      if (index === 0 && action === ACTIONS.NEXT) {
        // Switch to profile view when moving from welcome step to password step
        setSharedValue("Profile");

        // Delay the step progression to allow view switch
        setTimeout(() => {
          setTourState({ ...tourState, stepIndex: nextStepIndex });
        }, 500);
      } else if (index === 1 && action === ACTIONS.NEXT) {
        // Switch back to dashboard when moving from password step to dashboard tour
        setSharedValue("Dashboard");

        // Delay the step progression to allow view switch
        setTimeout(() => {
          setTourState({ ...tourState, stepIndex: nextStepIndex });
        }, 500);
      } else if (index === 2 && action === ACTIONS.PREV) {
        // Switch back to profile when going back from dashboard to password step
        setSharedValue("Profile");

        // Delay the step progression to allow view switch
        setTimeout(() => {
          setTourState({ ...tourState, stepIndex: nextStepIndex });
        }, 500);
      } else if (index === 1 && action === ACTIONS.PREV) {
        // Switch back to dashboard when going back from password step to welcome step
        setSharedValue("Dashboard");

        // Delay the step progression to allow view switch
        setTimeout(() => {
          setTourState({ ...tourState, stepIndex: nextStepIndex });
        }, 500);
      } else {
        setTourState({ ...tourState, stepIndex: nextStepIndex });
      }
    }
  };

  const joyrideStyles = {
    options: {
      arrowColor: "#fff",
      backgroundColor: "#fff",
      overlayColor: "rgba(0, 0, 0, 0.5)",
      primaryColor: "#192A3A",
      textColor: "#333",
      width: 300,
      zIndex: 1000,
    },
    tooltip: {
      fontSize: 14,
      padding: 20,
      borderRadius: 8,
    },
    tooltipContainer: {
      textAlign: "left",
    },
    tooltipTitle: {
      fontSize: 16,
      fontWeight: "bold",
      marginBottom: 10,
    },
    buttonNext: {
      backgroundColor: "#192A3A",
      fontSize: 13,
      fontWeight: "600",
      padding: "10px 20px",
      borderRadius: 6,
    },
    buttonBack: {
      color: "#192A3A",
      fontSize: 13,
      fontWeight: "600",
      padding: "10px 20px",
      borderRadius: 6,
    },
    buttonSkip: {
      color: "#6b7280",
      fontSize: 12,
    },
    beacon: {
      inner: "#192A3A",
      outer: "#192A3A",
    },
  };

  if (!runTour) return null;

  return (
    <Joyride
      callback={handleJoyrideCallback}
      continuous={true}
      hideCloseButton={false}
      run={tourState.run}
      scrollToFirstStep={true}
      showProgress={true}
      showSkipButton={true}
      stepIndex={tourState.stepIndex}
      steps={tourState.steps}
      styles={joyrideStyles}
      locale={{
        back: "Back",
        close: "Close",
        last: "Finish Tour",
        next: "Next",
        open: "Open the dialog",
        skip: "Skip Tour",
      }}
      disableOverlayClose={true}
      spotlightClicks={false}
      disableScrolling={false}
    />
  );
};

export default TenantTourMobile;
